// Measure inert copies with the same classes and DOM shape as the native
// prompt/RadioGroup. No React renderers, event handlers, audio or image requests
// run here. All segments share the largest measured height for this activity.
export function measureActivityPrompts(container, segments, width) {
  const owner=container.ownerDocument;
  const element=(tag,className,text)=>{const node=owner.createElement(tag);if(className)node.className=className;if(text!==undefined)node.textContent=text;return node;};
  const natural=node=>{node.style.setProperty('height','auto','important');node.style.setProperty('max-height','none','important');node.style.setProperty('overflow','visible','important');return node;};
  const measure=element('div','math-rods-prompt-measure');
  measure.setAttribute('aria-hidden','true');measure.inert=true;
  Object.assign(measure.style,{position:'absolute',left:'-100000px',top:'0',width:`${Math.max(1,width)}px`,visibility:'hidden',pointerEvents:'none'});
  const panels=[];
  for(const segment of segments){
    const content=natural(element('div','prompt-content'));
    let panel;
    if(segment.type==='choice'){
      panel=natural(element('section','choice-question-panel'));
      panel.style.fontSize=(segment.fontSize||24)+'px';
      const question=natural(element('div','choice-question-text'));
      question.append(natural(element('div','prompt',segment.text)));
      const answers=natural(element('div','choice-question-answers'));
      const fieldset=element('fieldset','native-math-rods-choices');fieldset.disabled=true;
      const radioGroup=element('div');let displayed=0;
      for(const [index,text] of (segment.choices||[]).entries()){
        if(!String(text).trim())continue;
        const label=element('label'),radio=element('input');radio.type='radio';radio.disabled=true;
        label.append(radio,owner.createTextNode(' '),element('span','',`${String.fromCharCode(65+displayed++)}. ${text}`));
        if(segment.choiceDetails?.[index]?.audio){
          const audio=element('button','choice-audio');audio.type='button';audio.disabled=true;
          const icon=element('span');Object.assign(icon.style,{display:'inline-block',width:'24px',height:'24px'});audio.append(icon);label.append(audio);
        }
        radioGroup.append(label);
      }
      fieldset.append(radioGroup);answers.append(fieldset);panel.append(question,answers);
    }else{
      panel=natural(element('div','prompt',segment.text));panel.style.fontSize=(segment.fontSize||24)+'px';
    }
    content.append(panel);measure.append(content);panels.push(content);
  }
  container.append(measure);
  try{return Math.ceil(Math.max(0,...panels.map(panel=>panel.offsetHeight)))+2;}
  finally{measure.remove();}
}
